import { IKnmUavType } from 'APIPackage/CatalogsModule/interfaces/IKnmUavType';

import { IUavTypeSelectOption } from '../interfaces/IUavTypeSelectOption';

export const createUavTypeSelectOption = (uavType: IKnmUavType): IUavTypeSelectOption => ({
  ...uavType,
  label: uavType.name,
  value: uavType.code,
});
